import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import CohortCard from "./CohortCard";
import { useDispatch, useSelector } from "react-redux";
import {
  setCohortApplied,
  setIsEditCohort,
  setResetSearchTextForAdditionalInstitutions,
  setResetSearchTextForCities,
  setSelectedCohort,
} from "../../../../rtk-query/features/cohort/cohortSlice";
import exportimages from "../../../../assets/images/exportImages";
import { fnCheckDollarUnits } from "../../report/widget/widgetsCommonFunction";

const CustomCohort = ({ cohortList }) => {
  const dispatch = useDispatch();
  const selectedCohort = useSelector(
    (state) => state?.cohortReducer?.selectedCohort,
  );

  const firstSelectedRef = useRef(null);
  useLayoutEffect(() => {
    if (!firstSelectedRef?.current) return;

    requestAnimationFrame(() => {
      firstSelectedRef?.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    });
  }, [selectedCohort?.uid, cohortList?.length]);

  const [validCohortList, setValidCohortList] = useState([]);

  useEffect(() => {
    setValidCohortList(cohortList?.filter((i) => i?.cohortType === 2));
  }, [cohortList]);

  const [showNoData, setShowNoData] = useState(false);
  useEffect(() => {
    if (validCohortList?.length === 0) {
      setTimeout(() => setShowNoData(true), 1000);
    } else {
      setShowNoData(false);
    }
  }, [validCohortList]);

  return (
    <div className="list-cohort">
      {validCohortList?.length > 0
        ? validCohortList?.map((cohort) => {
            const cohortResult = cohort?.cohortResult;
            const filterJson = cohort?.filterJson;
            const { score: minAssetSize, unit: minAssetSizeUnit } =
              fnCheckDollarUnits(Number(filterJson?.assets?.min) ?? 0);
            const { score: maxAssetSize, unit: maxAssetSizeUnit } =
              fnCheckDollarUnits(Number(filterJson?.assets?.max) ?? 0);
            const isSelected = selectedCohort?.uid === cohort?.uid;
            const isDefault = cohort?.isDefault;

            return (
              cohort?.cohortType === 2 && (
                <div
                  key={cohort.uid}
                  ref={isSelected ? firstSelectedRef : null}
                  onClick={() => {
                    dispatch(setSelectedCohort(cohort));
                    dispatch(setCohortApplied(null));
                    dispatch(setIsEditCohort(false));
                    dispatch(setResetSearchTextForAdditionalInstitutions(true));
                     dispatch(setResetSearchTextForCities(true));
                  }}
                  className="w-100"
                >
                  <CohortCard
                    uid={cohort?.uid}
                    title={cohort?.name}
                    subtitle={cohort?.description}
                    range={`$${minAssetSize?.toFixed(2)}${minAssetSizeUnit} – $${maxAssetSize?.toFixed(2)}${maxAssetSizeUnit}`}
                    // range={`$${filterJson?.assets?.min} – $${filterJson?.assets?.max}`}
                    institutions={cohortResult?.institution_count}
                    avg={cohortResult?.cohort_avg}
                    percentile={cohortResult?.percentile}
                    enableOptions={true}
                    isDefault={isDefault}
                  />
                </div>
              )
            );
          })
        : showNoData && (
            <div className="message-container">
              <div className="no_cohort">
                <img alt="icon" src={exportimages.no_cohort} />
              </div>
              <div className="message">No Custom Cohorts Yet</div>
              <div className="desc">
                You haven't created any cohorts. Use filters to shape your own
                cohort or duplicate a suggested one to get started.
              </div>
            </div>
          )}
    </div>
  );
};

export default CustomCohort;
